import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000151FindRequest = Partial<{
  shokaKbn: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCdFrom: string;
  nonyushitenCdFrom: string;
  nonyuCdTo: string;
  nonyushitenCdTo: string;
  torihikishuryoYmd: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000151FindResponse = {
  nonyuCd: string;
  nonyushitenCd: string;
  tokuiNm1: string;
  tokuiNm2: string;
  tokuiKana: string;
  tokuiCd: string;
  tokuishitenCd: string;
  hyojunnonyuKbn: string;
  shainCd: string;
  tokuiKbn: string;
  tokuiNmr: string;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shokuchiKbn: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  seikyuKbn: string;
  seikyuCd: string;
  seikyushitenCd: string;
  urikakeKbn: string;
  urikakeCd: string;
  urikakeshitenCd: string;
  nonyuKbn: string;
  urikakeshainCd: string;
  tankaKakeritsu: string;
  tokuibunCd1: string;
  tokuibunCd2: string;
  tokuibunCd3: string;
  tokuibunCd4: string;
  tokuibunCd5: string;
  zeiKbn: string;
  zeimarumeKbn: string;
  zeihasuichi: string;
  kinmarumeKbn: string;
  kinhasuichi: string;
  shokaKbn: string;
  denpyoshubetsuCd: string;
  denpyoKbn: string;
  tenpudenpyoCd: string;
  ritsu: string;
  bunrui: string;
  torihikisakiCd: string;
  hyakatenCd: string;
  shutsuryokushohinCd: string;
  jodaihyojiKbn: string;
  unsogaishaCd: string;
  shimeD1: string;
  kaishuyoteiM1: string;
  kaishuyoteiD1: string;
  seikyushoKbn: string;
  seikyushokeishikiKbn: string;
  seikyushosaibanKbn: string;
  seikyushoNo: string;
  kaishuKbn: string;
  itakusokoCd: string;
  shatenCd: string;
  kigyoCd: string;
  tenpoCd: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  kyakusakinoKbn: string;
  sakujoyoteiKbn: string;
};

export const B000151Find = (props: B000151FindRequest) => {
  return RestClient.get<PageableResponse<B000151FindResponse[]>>(
    "b000151/find",
    {
      params: props,
    }
  );
};

export type B000151GetRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
};

export const B000151Get = (props: B000151GetRequest) => {
  return RestClient.get("b000151/get", {
    params: props,
  });
};

//納入先名表示(得意先マスタ.得意先名略を取得する場合)
export const B000151NonyuNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCd === "" || data.nonyushitenCd === "") {
    methods.setValue("nonyuNmr", "");
    return;
  }
  await B000151Get({ tokuiCd: data.nonyuCd, tokuishitenCd: data.nonyushitenCd })
    .then((response) => {
      methods.setValue("nonyuNmr", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNmr", "");
    });
};

//納入先名表示
export const B000151NonyuNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCd === "" || data.nonyushitenCd === "") {
    methods.setValue("nonyuNm", "");
    return;
  }
  await B000151Get({ tokuiCd: data.nonyuCd, tokuishitenCd: data.nonyushitenCd })
    .then((response) => {
      methods.setValue("nonyuNm", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNm", "");
    });
};

//納入先名表示(得意先マスタ.得意先名1を取得する場合)
export const B000151NonyuNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCd === "" || data.nonyushitenCd === "") {
    methods.setValue("nonyuNm", "");
    return;
  }
  await B000151Get({ tokuiCd: data.nonyuCd, tokuishitenCd: data.nonyushitenCd })
    .then((response) => {
      methods.setValue("nonyuNm", response.data.tokuiNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNm", "");
    });
};

//納入先名(From)表示
export const B000151NonyuNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCdFrom === "" || data.nonyushitenCdFrom === "") {
    methods.setValue("nonyuNmFrom", "");
    return;
  }
  await B000151Get({
    tokuiCd: data.nonyuCdFrom,
    tokuishitenCd: data.nonyushitenCdFrom,
  })
    .then((response) => {
      methods.setValue("nonyuNmFrom", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNmFrom", "");
    });
};

//納入先名(To)表示
export const B000151NonyuNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCdTo === "" || data.nonyushitenCdTo === "") {
    methods.setValue("nonyuNmTo", "");
    return;
  }
  await B000151Get({
    tokuiCd: data.nonyuCdTo,
    tokuishitenCd: data.nonyushitenCdTo,
  })
    .then((response) => {
      methods.setValue("nonyuNmTo", response.data.tokuiNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("nonyuNmTo", "");
    });
};

//納入先名表示
export const B000151TokuiNm1 = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.nonyuCd === "" || data.nonyushitenCd === "") {
    methods.setValue("tokuiNm1", "");
    return;
  }
  await B000151Get({ tokuiCd: data.nonyuCd, tokuishitenCd: data.nonyushitenCd })
    .then((response) => {
      methods.setValue("tokuiNm1", response.data.tokuiNm1 ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("tokuiNm1", "");
    });
};
